import type { NamespaceValidationStatus } from './unusedPaddocks'

export const joinMessages = (messages: (string | null)[]) => {
  const present = messages.filter(Boolean)
  return present.length ? present.join('\n') : null
}

export function mergeValidatorStatuses(
  statuses: NamespaceValidationStatus[],
): NamespaceValidationStatus {
  const disabled = statuses.some(status => status.disabled)
  // Product decision (card 5557): a disabled tab's badge counts only what disables it; the
  // tooltip still lists every message.
  const badgeStatuses = disabled ? statuses.filter(status => status.disabled) : statuses

  return {
    disabled,
    readOnly: statuses.some(status => status.readOnly),
    totalError: badgeStatuses.reduce((total, status) => total + (status.totalError ?? 0), 0),
    error: joinMessages(statuses.map(status => status.error)),
  }
}

export function mergeNamespaceStatus(
  dependencyStatus: true | NamespaceValidationStatus,
  findingsStatus: NamespaceValidationStatus,
): NamespaceValidationStatus {
  // `unresolvedFindings` signals "no message" with '', the paddock validators with null.
  // Normalise to null so the Tab tooltip has a single empty sentinel to check.
  const findingsMessage = findingsStatus.error || null

  if (dependencyStatus === true) return { ...findingsStatus, error: findingsMessage }

  return {
    // Findings never gate a tab: disabling and read-only stay owned by the paddock validators.
    disabled: dependencyStatus.disabled,
    ...('readOnly' in dependencyStatus ? { readOnly: dependencyStatus.readOnly } : {}),
    totalError: (dependencyStatus.totalError ?? 0) + (findingsStatus.totalError ?? 0),
    error: joinMessages([dependencyStatus.error, findingsMessage]),
  }
}
